// queries/useActivateAccount.ts
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../axios';
import { responseHandler } from '../utils';

type MutationParams = {
    email: string;
};

type ActivateAccountResponse = {
    success: boolean;
    message: string;
};

export const useActivateAccount = (
  options?: UseMutationOptions<ActivateAccountResponse, AxiosError, MutationParams>,
): UseMutationResult<ActivateAccountResponse, AxiosError, MutationParams> => useMutation<ActivateAccountResponse,
    AxiosError, MutationParams>({
      mutationFn: ({ email }) => axiosInstance.post('/v3-activateAccount', { email }, {
        headers: { 'Content-Type': 'application/json' },
      }).then(responseHandler),
      ...options,
    });
